import { createAction } from "typesafe-actions";

export const setPreferredProcessingMode = createAction('SET_PREFERRED_PROCESSING_MODE')<'local' | 'cloud'>();

export const setAppColorMode = createAction('SET_APP_COLOR_MODE')<string>();
